/**
 * registryLabel names a registry for a dropdown, URL first: the URL is what
 * identifies the source being pulled from, and the name follows to tie it back to
 * the registry entry. Two registries can share a name, and a name on its own does
 * not say where it points.
 */
export function registryLabel(url: string, name: string): string {
  return url ? `${url} (${name})` : name;
}
